export const GET_JOBS = `
  query GetJobs($where: jobs_bool_exp, $limit: Int, $offset: Int, $order_by: [jobs_order_by!] = [{ created_at: desc }]) {
    jobs_aggregate(where: $where) {
      aggregate { count }
    }
    jobs(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      company_id
      job_type
      job_type_id
      job_type_obj: job_type_rel {
        id
        name
        is_project_based
        status_group
      }
      job_title
      description_of_job
      job_status
      contract_id
      firm_id
      job_assignment_id
      firm_short_name
      firm_established
      project_number
      teknopark_unit
      forward_to_argenet
      consulting_scope
      no_financial_needed
      post_approval_report_required
      post_completion_report_required
      job_reports
      project_extensions
      # Gecmis tablosu (JobHistorySection) bu alanlardan cizilir.
      # Onceden ayni dugumde IKI ayri job_details blogu vardi; GraphQL
      # onlari birlestirdigi icin calisiyordu ama her biri tek basina
      # eksikti. Birini silen bir degisiklik tabloyu sessizce bosaltirdi.
      job_details(order_by: { created_at: desc }) {
        id
        job_detail_type
        detail_data
        created_at
        updated_at
        user {
          first_name
          last_name
        }
      }
      created_by
      created_at
      updated_at
      company {
        name
        id
      }
      user {
        first_name
        last_name
      }
      contract {
        id
        contract_subject {
          id
          name
          is_project_based
        }
        scope_of_work {
          id
          name
        }
        contract_signing_date
        work_start_date
        work_status {
          id
          name
        }
        firm {
          id
          firm_name
          firm_short_name
          firm_city
          description
          luca_code
          is_established
          firm_partners { partner { id partner_name } }
          firm_sectors { sector { id sector_name } }
        }
        pricing_method {
          id
          name
        }
        auto_renewal
        renewal_period
        inflation_clause
        work_started_without_contract
        protocol_start_date
        protocol_end_date
        comment
        company_id
        firm_id
        firm_short_name
        created_at
        updated_at
        contract_pdf_key
        protocol_pdf_key
        contract_pdf_size
        protocol_pdf_size
        # Sözleşmeye bağlı diğer işler — ContractDetailsModal'da
        # "İlgili İşler" listesi bu alandan render edilir (Task 1).
        jobs {
          id
          job_title
          job_status
        }
      }
      job_tags {
        id
        tag_id
        created_at
        tag {
          id
          name
          tags_color
          tags_page
        }
      }
      job_assignment {
        id
        technical_team_id
        technical_user_id
        financial_team_id
        financial_user_id
        technical_team {
          id
          name
        }
        technical_user {
          id
          first_name
          last_name
        }
        financial_team {
          id
          name
        }
        financial_user {
          id
          first_name
          last_name
        }
        assigned_by_user {
          id
          first_name
          last_name
        }
      }
    }
  }
`;

export const GET_JOB_DETAILS = `
  query GetJobDetails($job_id: uuid!) {
    jobs_by_pk(id: $job_id) {
      project_extensions
    }
    job_details(where: { job_id: { _eq: $job_id } }, order_by: { created_at: desc }) {
      id
      job_id
      job_detail_type
      detail_data
      created_by
      created_at
      updated_at
      user {
        id
        first_name
        last_name
      }
    }
  }
`;

// job_status enum tablosunun TAM listesi. UI'da is durumu secimi yapan
// yerler (ornegin Akis olustur/duzenle dialoglari) bu listeyi hardcode
// etmek yerine buradan okur — DB'ye yeni bir durum eklendiginde kod
// degisikligi gerekmez.
export const GET_JOB_STATUSES_QUERY = `
  query GetJobStatuses {
    job_status(order_by: { name: asc }) {
      name
    }
  }
`;